#import "./field-answer-rule-fragment.graphql"

fragment FormFieldFragment on FormField {
    id
    type
    label
    placeholder
    styles
    subfields
    isSeparateFields
    defaultValues
    entityName
    fieldName
    entityTypes
    isRequired
    isRemovable
    attribute {
        id
        name
        type
    }
    image {
        fileId
        name
        imageUrl
    }
    originalFieldId
    originalFieldApiId
    rules {
        ...FieldAnswerRuleFragment
    }
}
